import React, {useCallback, useContext, useEffect} from "react";
import {TextField} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {WizardContext} from "../Wizard";
import moment from "moment";
import {CHANGE_OPTION_INPUT_DATA} from "../../WizardConstants";
import {WizardFormTitle} from "../wizardForm/wizardFormTitle";

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    textFiled: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200
    }
}))

export function WizardFormDate({ data }) {
    const classes = useStyles();
    const { keyData, dispatch } = useContext(WizardContext);

    const defaultVal = moment(new Date(keyData.pickup_dtm)).format("YYYY-MM-DDTHH:mm");
    const currentItem = keyData.order_value.find((item) => item.t_order_item_name === data.name);
    const currentValue = currentItem?.direct_text || defaultVal;

    useEffect(() => {
        if (!currentItem?.direct_text) {
            dispatch({ type: CHANGE_OPTION_INPUT_DATA, dataName: data.name, optionName: data.name, optionValue: defaultVal })
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onChange = useCallback((e) => {
            dispatch({ type: CHANGE_OPTION_INPUT_DATA, dataName: e.target.name, optionName: e.target.name, optionValue: e.target.value })
        },
        [dispatch],
    );

    return (
        <div className="form-group">
            <WizardFormTitle musthave={data.musthave} name={data.name} description={data.description}/>
            <TextField
                id="datetime-local"
                type="datetime-local"
                value={currentValue}
                className={classes.textFiled}
                InputLabelProps={{shrink:true,}}
                label={data.name}
                name={data.name}
                onChange={onChange}
            />

        </div>
    )
}